import React from "react";

import Grid from "@mui/material/Grid";
import Card from "@mui/material/Card";
import CardContent from "@mui/material/CardContent";
import Typography from "@mui/material/Typography";
import {useTranslation} from "react-i18next";
import {useTheme} from "@mui/material/styles";
import Plotting from "./Plotting";

export default function AnalyzeAFS(props) {
    // init internationalization
    const {t} = useTranslation();
    const theme = useTheme();

    return (
        <>
            {props.runData.afsDetails && (
                <>
                    <Grid item xl={9} xs={6} sx={{marginTop: theme.spacing(4)}}/>
                    <Grid item xl={12} md={12} sm={12}>
                        <Grid container spacing={2} row-spacing={6}>
                            <Grid item xl={8} md={12} sm={12}>
                                <Card>
                                    <Plotting runData={{...props.runData.afsDetails.progressStats , ...props.runData.afsDetails.finalStats}} type="AFSScatter"/>
                                </Card>
                            </Grid>
                            <Grid item xl={4} md={12} sm={12}>
                                <Card sx={{backgroundColor: theme.palette.background.default}}>
                                    <CardContent>
                                        <Typography gutterBottom variant="h5" component="div">
                                            {t("analyzer.AFSScatterTitle")}
                                        </Typography>
                                        <Typography variant="body2" color="text.secondary">
                                            {t("analyzer.AFSScatterDescriptionBody")}
                                        </Typography>
                                    </CardContent>
                                </Card>
                            </Grid>
                            <Grid item xl={8} md={12} sm={12}>
                                <Card>
                                    <Plotting runData={{ ...props.runData.afsDetails.selectedFeaturesProgress, ...props.runData.afsDetails.finalStats}}
                                              type="AFSHeatmap"/>
                                </Card>
                            </Grid>
                            <Grid item xl={4} md={12} sm={12}>
                                <Card sx={{backgroundColor: theme.palette.background.default}}>
                                    <CardContent>
                                        <Typography gutterBottom variant="h5" component="div">
                                            {t("analyzer.AFSHeatmap")}
                                        </Typography>
                                        <Typography variant="body2" color="text.secondary">
                                            {t("analyzer.AFSHeatmapDescriptionBody")}
                                        </Typography>
                                    </CardContent>
                                </Card>
                            </Grid>
                        </Grid>
                    </Grid>
                </>
            )}
        </>
    )
}







